<template>
  <div>
    <div class="floorSix" :style="{ backgroundImage: 'url(' + backImg + ')' }">
      <div class="title_box">
        <div class="en">SHOW INSTALLATION</div>
        <div class="zh">安装便捷，美好体验快人一步</div>
        <div class="zh1">
          无需水泥砂浆，使用专用环保地板胶粘贴或锁扣安装后就可使用
        </div>
        <div class="line"></div>
      </div>
      <div class="content_box">
        <div class="left_box">
          <div class="img_box">
            <img
              class="img_cover"
              v-if="installArr.length"
              :src="installArr[activeImg].image"
              alt=""
            />
          </div>
          <div class="back_box"></div>
        </div>
        <div class="right_box">
          <div
            class="item_step"
            :class="activeImg === index ? 'item_step1' : ''"
            @mouseenter="stepEnter(index)"
            v-for="(item, index) in installArr"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      installArr: [],
      activeImg: 0,
      backImg: "",
      objimg:"",
      installArr: [],
    };
  },
  methods: {
    stepEnter(index) {
      this.activeImg = index;
    },
  },
  mounted() {
    var index = Number(this.$route.query.id);
    var indata = Number(this.$route.query.in);
    // if (this.floorData.length === 0) {
    //   // setTimeout(() => {
    //     var obj = this.$store.state.floorData[index];
    //     this.backImg = obj.install_background;
    //     this.installArr = obj.install_step;
    //   // }, 500);
    // } else {

    if (index == 0) {
      var obj =
        this.$store.state.floorData[index] ||
        JSON.parse(localStorage.getItem("floorData"))[index];
      this.backImg = obj.children[indata].install_background;
      this.installArr = obj.children[indata].install_step;
    } else {
      var obj =
        this.$store.state.floorData[index] ||
        JSON.parse(localStorage.getItem("floorData"))[index];
      this.backImg = obj.install_background;
      this.installArr = obj.install_step;
    }

    // }
  },
  computed: {
    floorData() {
      return this.$store.state.floorData;
    },
  },
  watch: {
    floorData(val) {
      console.log(val);
    },
  },
};
</script>

<style scoped lang='scss'>
.floorSix {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  // background-image: url("../../assets/components_img/temporary/floor_six_back.png");
  background-size: cover;
  .title_box {
    margin: 0 auto;
    // padding-top: 160px;
    padding-top: 16vh;
    // padding-top: 120px;
    height: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: relative;
    .en {
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.1);
      text-align: center;
    }
    .zh {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 58px;
      line-height: 5.8vh;
      color: #ffffff;
      text-align: center;
      width: 100%;
      position: relative;
      // top: -56px;
      top: -5vh;
    }
    .zh1 {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // line-height: 58px;
      line-height: 5.8vh;
      color: #ffffff;
      text-align: center;
      width: 100%;
      position: relative;
      // top: -56px;
      top: -5.6vh;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      position: relative;
      top: -56px;
    }
  }
  .content_box {
    width: 62.5vw;
    // height: 468px;
    height: 46.8vh;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left_box {
      // width: 752px;
      width: 39.16vw;
      // height: 468px;
      height: 46.8vh;
      position: relative;
      .img_box {
        // width: 742px;
        width: 38.6vw;
        // height: 458px;
        height: 45.8vh;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
      .back_box {
        width: 38.6vw;
        // height: 458px;
        height: 45.8vh;
        background: #0fffff;
        position: absolute;
        bottom: 0;
        left: 10px;
        z-index: 1;
      }
    }
    .right_box {
      // width: 360px;
      width: 17.18vw;
      // height: 216px;
      height: 21.6vh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .item_step {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // line-height: 24px;
        line-height: 2.4vh;
        color: #ffffff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: all 0.5s;
      }
      .item_step1 {
        color: #0fffff;
        transition: all 0.5s;
      }
      .item_step:hover {
        color: #0fffff;
        transition: all 0.5s;
        cursor: url("../../assets/cursor.png"), none;
      }
    }
  }
}
</style>